module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 1")]), _vm._v(" The Price of Glory")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter_2"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 2")]), _vm._v(" Holy War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 3")]), _vm._v(" Inaction at the Alma")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 4")]), _vm._v(" The Flank March")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 5")]), _vm._v(" The Siege of Sevastopol")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 6")]), _vm._v(" ‘The Brilliant Attack’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 7")]), _vm._v(" ‘That Thin Red Streak’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 8")]), _vm._v(" ‘Forward the Light Brigade’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 9")]), _vm._v(" ‘Magnificent But Not War’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 10")]), _vm._v(" ‘To Do or Die’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 11")]), _vm._v(" ‘Someone Had Blundered’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 12")]), _vm._v(" ‘Honour the Light Brigade’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Chapter 13")]), _vm._v(" Tarnished Glory")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References and Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography and Sources")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0